.contact-us {
  &__list {
    margin: 0;
    padding: 0;
    font: var(--cxsShell_MobileMenuFont);
  }

  &__list-item {
    border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
  }

  &__link .link {
    padding: var(--cxs-spacer-m);
  }
}

.phone {
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: var(--cxsShell_MenuTextColor);
    font-size: var(--cxs-font-size-base);
    font-weight: var(--cxs-font-weight-bold);
  }

  .link {
    padding: var(--cxs-spacer-m);
    color: var(--cxsShell_MenuTextColor);
    font-size: var(--cxs-font-size-base-4);
    font-weight: var(--cxs-font-weight-bold);
    direction: ltr;
  }

  .sub-title {
    font-size: var(--cxs-font-size-base-0);
  }
}

.contact {
  display: flex;
  font-family: var(--cxs-font-family-regular);

  .title {
    margin-block: 0 var(--cxs-spacer-s);
    color: var(--cxsShell_MenuTextColor);
    font-family: var(--cxs-font-family-regular);
    font-size: var(--cxs-font-size-base);
  }

  .sub-title {
    margin: 0;
    font-size: var(--cxs-font-size-base-0);
  }

  .icon-placeholder {
    margin-inline-end: var(--cxs-spacer-m);

    ds-icon {
      --ds-icon-width: #{rem(4)};
    }
  }
}

[data-mode='light'] {
  .contact-us {
    &__link .link {
      padding-block: rem(1);
      padding-inline: rem(.5) rem(.75);
    }
  }

  .phone {
    padding-block: rem(1);
    padding-inline: rem(.5) rem(.75);

    .link {
      line-height: normal;
    }
  }
}
